import { SettingsTab } from './SettingsTab'
import { connect } from 'react-redux'

const mapStateToProps = (state: { activeBot }) => ({
  activeBot: state.activeBot,
})

export default connect(mapStateToProps)(SettingsTab)
